import React from 'react';

export function Table({ children, className = '' }) {
  return (
    <div className={`bg-white rounded-xl border border-slate-200 overflow-hidden ${className}`}>
      <div className="overflow-x-auto">
        <table className="w-full">
          {children}
        </table>
      </div>
    </div>
  );
}

export function TableHeader({ children }) {
  return (
    <thead className="border-b border-slate-200 bg-gray-50">
      {children}
    </thead>
  );
}

export function TableBody({ children }) {
  return <tbody className="divide-y divide-slate-100">{children}</tbody>;
}

export function TableRow({ children, onClick, className = '' }) {
  return (
    <tr
      className={`hover:bg-gray-50 transition-colors ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

export function TableHead({ children, sortable, sortDirection, onSort, className = '' }) {
  const baseClass = 'text-left py-3 px-4 text-xs font-medium text-slate-500 uppercase tracking-wider';

  if (sortable) {
    return (
      <th
        scope="col"
        className={`${baseClass} cursor-pointer hover:bg-gray-100 select-none ${className}`}
        onClick={onSort}
      >
        <div className="flex items-center gap-1">
          {children}
          <span className="text-slate-400">
            {sortDirection === 'asc' ? '↑' : sortDirection === 'desc' ? '↓' : ''}
          </span>
        </div>
      </th>
    );
  }

  return (
    <th scope="col" className={`${baseClass} ${className}`}>
      {children}
    </th>
  );
}

export function TableCell({ children, className = '' }) {
  return (
    <td className={`py-3 px-4 text-sm text-slate-900 ${className}`}>
      {children}
    </td>
  );
}

// Empty state for table
export function TableEmpty({ message = 'データがありません', icon }) {
  return (
    <tr>
      <td colSpan="100%" className="py-16 text-center">
        {icon && (
          <div className="w-16 h-16 mx-auto mb-4 bg-slate-100 rounded-full flex items-center justify-center text-slate-400">
            {icon}
          </div>
        )}
        <p className="text-slate-500">{message}</p>
      </td>
    </tr>
  );
}
